import { render, staticRenderFns } from "./PurchaseRequisitions.vue?vue&type=template&id=6341f223&scoped=true&lang=pug&"
import script from "./PurchaseRequisitions.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitions.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisitions.vue?vue&type=style&index=0&id=6341f223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6341f223",
  null
  
)

export default component.exports